// components/ui/table/TableRow.jsx
export const TableRow = ({ children, className = "" }) => {
  return (
    <tr
      className={`border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted ${className}`}
    >
      {children}
    </tr>
  );
};
